<template>
  <div class="alipay-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-s-shop"></i> 采购商详情
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 卡片内容 -->
    <el-card class="alipay-card" shadow="never">
      <!-- 头部信息 -->
      <div class="detail-header">
        <div class="header-left">
          <div class="logo-box">
            <img v-if="detailInfo.logo" :src="detailInfo.logo" class="logo-img" />
            <i v-else class="el-icon-s-shop logo-placeholder"></i>
          </div>
          <div class="header-info">
            <h2>{{ detailInfo.name }}</h2>
            <div class="header-tags">
              <el-tag :type="detailInfo.status == 1 ? 'success' : 'danger'" size="small" effect="plain">
                {{ detailInfo.status == 1 ? '已启用' : '已禁用' }}
              </el-tag>
              <el-tag :type="detailInfo.location_type == 1 ? 'success' : 'primary'" size="small" effect="plain">
                {{ detailInfo.location_type == 1 ? '境内采购' : '境外采购' }}
              </el-tag>
              <el-tag v-if="detailInfo.is_recommend == 1" type="warning" size="small" effect="plain">
                <i class="el-icon-star-on"></i> 推荐
              </el-tag>
            </div>
          </div>
        </div>
        <div class="header-actions">
          <el-button type="primary" @click="goEdit" icon="el-icon-edit-outline" size="small">编辑</el-button>
          <el-button @click="goBack" icon="el-icon-back" size="small">返回</el-button>
        </div>
      </div>

      <!-- 统计卡片 -->
      <div class="stat-cards">
        <div class="stat-card">
          <div class="stat-icon view"><i class="el-icon-view"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ detailInfo.readed_num || 0 }}</div>
            <div class="stat-label">浏览次数</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon collect"><i class="el-icon-star-on"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ detailInfo.collection_num || 0 }}</div>
            <div class="stat-label">收藏次数</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon product"><i class="el-icon-goods"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ productCount }}</div>
            <div class="stat-label">产品数量</div>
          </div>
        </div>
      </div>

      <!-- 基本信息 -->
      <div class="info-section">
        <div class="section-title">
          <i class="el-icon-info"></i>
          <span>基本信息</span>
        </div>
        <el-descriptions :column="3" border size="small" class="info-descriptions">
          <el-descriptions-item label="采购商名称">{{ detailInfo.name || '-' }}</el-descriptions-item>
          <el-descriptions-item label="采购商编码">{{ detailInfo.sn || '-' }}</el-descriptions-item>
          <el-descriptions-item label="经营类型">{{ detailInfo.location_type == 1 ? '境内采购' : '境外采购' }}</el-descriptions-item>
          <el-descriptions-item label="联系人">{{ detailInfo.cont_name || '-' }}</el-descriptions-item>
          <el-descriptions-item label="联系电话">{{ detailInfo.mobile || '-' }}</el-descriptions-item>
          <el-descriptions-item label="电子邮箱">{{ detailInfo.email || '-' }}</el-descriptions-item>
          <el-descriptions-item label="企业法人">{{ detailInfo.artiperson || '-' }}</el-descriptions-item>
          <el-descriptions-item label="入驻时间">{{ detailInfo.join_time | formatDate }}</el-descriptions-item>
          <el-descriptions-item label="行业类型">{{ getBtypeText(detailInfo.btype) }}</el-descriptions-item>
        </el-descriptions>
      </div>

      <!-- 地区信息 -->
      <div class="info-section">
        <div class="section-title">
          <i class="el-icon-location"></i>
          <span>地区信息</span>
        </div>
        <el-descriptions :column="2" border size="small" class="info-descriptions">
          <el-descriptions-item label="所属地区" :span="2">
            {{ detailInfo.province || '' }} {{ detailInfo.city || '' }} {{ detailInfo.district || '' }}
          </el-descriptions-item>
          <el-descriptions-item label="详细地址" :span="2">{{ detailInfo.address || '-' }}</el-descriptions-item>
          <el-descriptions-item label="经纬度坐标" :span="2">
            <span v-if="detailInfo.lng && detailInfo.lat">
              经度 {{ detailInfo.lng }}，纬度 {{ detailInfo.lat }}
              <el-button type="text" size="mini" @click="showOnMap">查看地图</el-button>
            </span>
            <span v-else>-</span>
          </el-descriptions-item>
        </el-descriptions>
      </div>

      <!-- 社交账号 -->
      <div class="info-section">
        <div class="section-title">
          <i class="el-icon-share"></i>
          <span>社交账号</span>
        </div>
        <el-descriptions :column="3" border size="small" class="info-descriptions">
          <el-descriptions-item label="WhatsApp">{{ detailInfo.whatsapp || '-' }}</el-descriptions-item>
          <el-descriptions-item label="Facebook">{{ detailInfo.facebook || '-' }}</el-descriptions-item>
          <el-descriptions-item label="TikTok">{{ detailInfo.ticktok || '-' }}</el-descriptions-item>
          <el-descriptions-item label="Twitter">{{ detailInfo.twitter || '-' }}</el-descriptions-item>
          <el-descriptions-item label="官方网站">
            <a v-if="detailInfo.website" :href="detailInfo.website" target="_blank">{{ detailInfo.website }}</a>
            <span v-else>-</span>
          </el-descriptions-item>
          <el-descriptions-item label="所在国家">{{ detailInfo.nation || '-' }}</el-descriptions-item>
        </el-descriptions>
      </div>

      <!-- 企业信息 -->
      <div class="info-section">
        <div class="section-title">
          <i class="el-icon-office-building"></i>
          <span>企业信息</span>
        </div>
        <el-descriptions :column="1" border size="small" class="info-descriptions">
          <el-descriptions-item label="企业简介">{{ detailInfo.mini_description || '-' }}</el-descriptions-item>
          <el-descriptions-item label="主营业务">{{ detailInfo.remark || '-' }}</el-descriptions-item>
          <el-descriptions-item label="服务项目">{{ detailInfo.service || '-' }}</el-descriptions-item>
          <el-descriptions-item label="企业详细介绍">
            <div class="rich-content" v-html="detailInfo.description || '-'"></div>
          </el-descriptions-item>
        </el-descriptions>
      </div>

      <!-- 银行账户 -->
      <div class="info-section">
        <div class="section-title">
          <i class="el-icon-bank-card"></i>
          <span>银行账户</span>
        </div>
        <el-descriptions :column="2" border size="small" class="info-descriptions">
          <el-descriptions-item label="开户银行">{{ detailInfo.bank_name || '-' }}</el-descriptions-item>
          <el-descriptions-item label="银行账号">{{ detailInfo.bank_account || '-' }}</el-descriptions-item>
        </el-descriptions>
      </div>

      <!-- 店铺图片 -->
      <div class="info-section" v-if="detailInfo.shop_img || (shopImages && shopImages.length > 0)">
        <div class="section-title">
          <i class="el-icon-picture"></i>
          <span>店铺图片</span>
        </div>
        <div class="image-list">
          <div 
            v-for="(img, index) in shopImages" 
            :key="index" 
            class="image-item"
            @click="previewImage(index)"
          >
            <el-image :src="img.url || img" fit="cover" :preview-src-list="imageList" :initial-index="index">
              <div slot="placeholder" class="image-placeholder"><i class="el-icon-loading"></i></div>
              <div slot="error" class="image-error"><i class="el-icon-picture-outline"></i></div>
            </el-image>
          </div>
        </div>
      </div>

      <!-- 底部按钮 -->
      <div class="form-actions">
        <el-button @click="goBack" icon="el-icon-back" size="medium">返回</el-button>
        <el-button type="primary" @click="goEdit" icon="el-icon-edit" size="medium">编辑</el-button>
      </div>
    </el-card>

    <!-- 地图弹框 -->
    <el-dialog title="位置地图" :visible.sync="mapDialogVisible" width="700px" class="alipay-dialog">
      <div id="map-container" class="map-container"></div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import AMapLoader from '@amap/amap-jsapi-loader'

export default {
  name: "shopForeignInfo",
  data() {
    return {
      detailInfo: {},
      shopImages: [],
      productCount: 0,
      mapDialogVisible: false,
      map: null
    }
  },
  computed: {
    imageList() {
      return this.shopImages.map(img => img.url || img)
    }
  },
  mounted() {
    const id = this.$route.query.id
    if (id && !isNaN(id) && id > 0) {
      this.getDetail(id)
    } else {
      this.$message.error('采购商ID不存在')
      this.goBack()
    }
  },
  beforeDestroy() {
    if (this.map) {
      this.map.destroy()
      this.map = null
    }
  },
  filters: {
    formatDate(time) {
      return time ? moment(time * 1000).format('YYYY-MM-DD HH:mm:ss') : '-'
    }
  },
  methods: {
    // 获取行业类型文本
    getBtypeText(btype) {
      const map = { 1: '零售业', 2: '批发业', 3: '制造业', 4: '服务业' }
      return map[btype] || '-'
    },
    
    // 获取详情
    getDetail(id) {
      const param = {
        id: id,
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id')
      }
      this.$axios.purchaserOne(param).then(res => {
        if (res.code == 200) {
          this.detailInfo = res.data
          // 处理店铺图片
          if (this.detailInfo.shop_img) {
            this.shopImages = this.detailInfo.shop_img.split(',').filter(i => i)
          }
        } else {
          this.$message.error(res.msg || '获取详情失败')
        }
      }).catch(error => {
        console.error('获取详情失败:', error)
        this.$message.error('获取详情失败')
      })
    },
    
    // 预览图片
    previewImage(index) {
      this.$previewImage(this.imageList, index)
    },
    
    // 在地图上显示位置
    async showOnMap() {
      if (!this.detailInfo.lng || !this.detailInfo.lat) {
        this.$message.warning('暂无坐标信息')
        return
      }
      
      this.mapDialogVisible = true
      await this.$nextTick()
      
      try {
        const AMap = await AMapLoader.load({
          key: 'a50f6a3b0f5058fa09bfbf6ad5acb4e3',
          version: '2.0',
          plugins: ['AMap.Scale', 'AMap.ToolBar']
        })
        
        this.map = new AMap.Map('map-container', {
          zoom: 15,
          center: [parseFloat(this.detailInfo.lng), parseFloat(this.detailInfo.lat)],
          resizeEnable: true
        })
        
        const marker = new AMap.Marker({
          position: [parseFloat(this.detailInfo.lng), parseFloat(this.detailInfo.lat)],
          map: this.map,
          title: this.detailInfo.name
        })
        
        const infoWindow = new AMap.InfoWindow({
          content: `<div style="padding: 8px 12px;"><strong>${this.detailInfo.name}</strong><br/>${this.detailInfo.address || ''}</div>`,
          offset: new AMap.Pixel(0, -30)
        })
        
        marker.on('click', () => {
          infoWindow.open(this.map, marker.getPosition())
        })
        
      } catch (error) {
        console.error('地图加载失败:', error)
        this.$message.error('地图加载失败')
      }
    },
    
    // 编辑
    goEdit() {
      this.$router.push({
        path: '/shopForeignForm',
        query: { id: this.detailInfo.id }
      })
    },
    
    // 返回列表
    goBack() {
      this.$router.push('/shopForeignList')
    }
  }
}
</script>

<style lang="scss" scoped>
.alipay-container {
  padding: 16px 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.breadcrumb-wrapper {
  margin-bottom: 16px;
  .el-breadcrumb { font-size: 14px; i { margin-right: 4px; } }
}

.alipay-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  &:hover { box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08); }
  .el-card__body { padding: 24px; }
}

// 详情头部
.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid #f0f0f0;
  
  .header-left {
    display: flex;
    align-items: center;
    gap: 20px;
    
    .logo-box {
      width: 80px;
      height: 80px;
      border-radius: 16px;
      background: #f8f9fc;
      border: 1px solid #e4e7ed;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      
      .logo-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      
      .logo-placeholder {
        font-size: 48px;
        color: #c0c4cc;
      }
    }
    
    .header-info {
      h2 {
        font-size: 20px;
        font-weight: 600;
        color: #1f2d3d;
        margin: 0 0 8px 0;
      }
      
      .header-tags {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
      }
    }
  }
  
  .header-actions {
    display: flex;
    gap: 12px;
    
    .el-button { border-radius: 20px; }
    .el-button--primary { background: #1677ff; border-color: #1677ff; }
  }
}

// 统计卡片
.stat-cards {
  display: flex;
  gap: 20px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  
  .stat-card {
    flex: 1;
    min-width: 140px;
    background: linear-gradient(135deg, #fff 0%, #f8f9fc 100%);
    border-radius: 16px;
    padding: 16px 20px;
    display: flex;
    align-items: center;
    gap: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    
    .stat-icon {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      color: #fff;
      
      &.view { background: linear-gradient(135deg, #1677ff, #4096ff); }
      &.collect { background: linear-gradient(135deg, #e6a23c, #ebb563); }
      &.product { background: linear-gradient(135deg, #00b578, #1acd8c); }
    }
    
    .stat-info {
      .stat-value { font-size: 28px; font-weight: 700; color: #1f2d3d; }
      .stat-label { font-size: 13px; color: #8c8f98; margin-top: 4px; }
    }
  }
}

// 信息区块
.info-section {
  margin-bottom: 24px;
  
  .section-title {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
    padding-left: 8px;
    border-left: 3px solid #1677ff;
    
    i { font-size: 16px; color: #1677ff; }
    span { font-size: 15px; font-weight: 600; color: #1f2d3d; }
  }
}

.info-descriptions {
  ::v-deep .el-descriptions-item__label {
    background: #f8f9fc;
    font-weight: 500;
    color: #606266;
    width: 130px;
  }
}

// 富文本内容
.rich-content {
  ::v-deep img { max-width: 100%; }
  ::v-deep p { margin: 0 0 8px; line-height: 1.6; }
}

// 图片列表
.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 12px;
  
  .image-item {
    width: 120px;
    height: 120px;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    border: 1px solid #e4e7ed;
    transition: all 0.3s;
    
    &:hover {
      transform: scale(1.02);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
    
    ::v-deep .el-image { width: 100%; height: 100%; }
    
    .image-placeholder, .image-error {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      background: #f8f9fc;
      color: #c0c4cc;
      font-size: 24px;
    }
  }
}

// 底部按钮
.form-actions {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
  
  .el-button { border-radius: 24px; padding: 10px 28px; }
  .el-button--primary { background: #1677ff; border-color: #1677ff; }
}

// 地图容器
.map-container {
  width: 100%;
  height: 400px;
  border-radius: 12px;
  overflow: hidden;
}

// 响应式
@media (max-width: 768px) {
  .detail-header { flex-direction: column; align-items: flex-start; gap: 16px; .header-actions { align-self: flex-end; } }
  .info-descriptions ::v-deep .el-descriptions-item__label { width: 100px; }
}
</style>